import React from 'react';
import { Div } from '@icecreamsocial/components';
import {
	BusinessProfileForm,
	EditFormControls,
	Pagename,
} from '../../../../presentational';
import { useBusiness } from '../../../../providers/Business';

const BusinessSettings = () => {
	const { business, update } = useBusiness();
	const { data, isLoading } = business;

	const initialValues = {
		businessName: data?.name,
		businessAddress: data?.businessAddress,
		supportEmail: data?.supportEmail,
		currency: data?.currency,
		language: data?.language,
		marketVertical: { value: data?.marketVertical?.id, label: data?.marketVertical?.segmentName },
		marketSubCategory: { value: data?.marketSubCategory?.id, label: data?.marketSubCategory?.segmentName },
	};

	const handleSubmit = (values) => update.mutate(values);

	return (
		<Div>
			<Pagename>Business Profile</Pagename>
			<BusinessProfileForm
				{...initialValues}
				onSubmit={handleSubmit}
				renderControls={(props) => (
					<EditFormControls
						isLoading={isLoading}
						disabled={isLoading}
						{...props}
					/>
				)}
			/>
		</Div>
	);
};

BusinessSettings.displayName = 'Settings.Business.Profile';
export default BusinessSettings;
